export default "__VITE_ASSET__BBZrmQJ5__"